define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ApplicantRole = void 0;
    class ApplicantRole extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "ApplicantId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicantIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicantType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApplicantTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Applicant", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, ApplicantRole.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Applicant = parent;
            this.ApplicantId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Applicant = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.ApplicantId = (0, EntityUtil_1.toInt)(entity.ApplicantId);
            a.ApplicantType = (0, EntityUtil_1.toInt)(entity.ApplicantType);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, ApplicantRole.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                ApplicantId: this.ApplicantId,
                ApplicantType: this.ApplicantType,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.ApplicantRole = ApplicantRole;
    Object.defineProperty(ApplicantRole, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "ApplicantRole"
    });
    Object.defineProperty(ApplicantRole, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Permit Application Applicant Roles"
    });
    Object.defineProperty(ApplicantRole, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "ApplicantId", "ApplicantType"]
    });
    Object.defineProperty(ApplicantRole, "ApplicantIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(ApplicantRole, "ApplicantTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(ApplicantRole, "ApplicantTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], ApplicantRole.prototype, "ApplicantId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ApplicantRole.prototype, "ApplicantIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ApplicantRole.prototype, "ApplicantType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ApplicantRole.prototype, "ApplicantTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ApplicantRole.prototype, "Applicant", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ApplicantRole.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ApplicantRole.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ApplicantRole.prototype, "merge", null);
});
